import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Preloader from './components/Preloader';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import GDPRBanner from './components/GDPRBanner';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Locations from './pages/Locations';
import Team from './pages/Team';
import Contact from './pages/Contact';
import FAQs from './pages/FAQs';
import Partners from './pages/Partners';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import GDPRInformation from './pages/GDPRInformation';
import CookiePolicy from './pages/CookiePolicy';
import './styles/App.css';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [gdprAccepted, setGdprAccepted] = useState(false);

  useEffect(() => {
    // Check if GDPR was previously accepted
    const gdprStatus = localStorage.getItem('gdpr-accepted');
    if (gdprStatus) {
      setGdprAccepted(true);
    }

    // Simulate loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleGDPRAccept = () => {
    localStorage.setItem('gdpr-accepted', 'true');
    setGdprAccepted(true);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Active Care  | Supported Residential Accommodation | Building Futures, Supporting Lives</title>
        <meta name="description" content="Safe, nurturing residential accommodation for vulnerable adults. Person-centered care, therapeutic support, and rehabilitation services. Registration: 14464980" />
        <meta name="keywords" content="residential care, vulnerable adults, supported accommodation, therapeutic care, UK care services, safeguarding" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta property="og:title" content="Active Care Low - Supported Residential Accommodation" />
        <meta property="og:description" content="Safe, nurturing care for vulnerable adults with registration 14464980" />
        <meta name="theme-color" content="#2e5c8a" />
      </Helmet>

      {isLoading && <Preloader />}

      <Router>
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/gdpr-information" element={<GDPRInformation />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Routes>
        </main>
        <ScrollToTop />
        <Footer />
      </Router>

      {!gdprAccepted && <GDPRBanner onAccept={handleGDPRAccept} />}
    </>
  );
}

export default App;
